module.exports = __webpack_public_path__ + "static/media/advantage.1598ee75.png";